import React, { useEffect, useState } from "react";
import { api } from "@/lib/kielo";
import { useI18n } from "@/i18n";
import { Flame, Mountain, Coffee, Sun, Trees, Utensils, Home, Snowflake, Sparkles } from "lucide-react";

const ICONS = { flame: Flame, mountain: Mountain, coffee: Coffee, sun: Sun, trees: Trees, utensils: Utensils, home: Home, snowflake: Snowflake };

export default function Culture() {
  const { t, lang } = useI18n();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    api.get("/culture", { params: { lang } }).then(({ data }) => setCards(data));
  }, [lang]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-testid="culture-page">
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#0E382B] tracking-tight">{t("culture.title")}</h1>
      <p className="mt-2 text-[#52635B] text-base">{t("culture.sub")}</p>

      {!cards.length ? (
        <p className="mt-10 text-[#52635B]">{t("common.loading")}</p>
      ) : (
        <div className="mt-8 grid gap-6 sm:grid-cols-2">
          {cards.map((c) => {
            const Icon = ICONS[c.icon] || Sparkles;
            return (
              <article key={c.id} data-testid={`culture-card-${c.id}`} className="rounded-3xl bg-white border border-[#E9E6DF] overflow-hidden">
                <div className="flex items-center gap-3 px-6 pt-6">
                  <span className="w-11 h-11 rounded-2xl bg-[#0E382B] text-white flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </span>
                  <div>
                    <h3 className="font-serif text-xl font-semibold text-[#0E382B] leading-tight">{c.title}</h3>
                    <p className="text-xs text-[#8A5A1E] font-medium">{c.fi}</p>
                  </div>
                </div>
                <p className="px-6 mt-4 text-[#3E4B45] leading-relaxed text-[15px]">{c.body}</p>
                <div className="mt-5 px-6 py-4 bg-[#F6ECDD] border-t border-[#EADFCB] flex items-start gap-2">
                  <Sparkles className="w-4 h-4 text-[#8A5A1E] mt-0.5 shrink-0" />
                  <p className="text-sm text-[#5E4A24]"><span className="font-semibold">{t("culture.funFact")} </span>{c.funFact}</p>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
